import axios from 'axios';

// Base URL for the API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

/**
 * Fetch clients with multiple orders
 * @returns {Promise<Array>} List of clients with multiple orders
 */
const ATUH_TOKEN = localStorage.getItem('authToken');
export const fetchClientsWithMultipleOrders = async () => {
    try {

        const response = await axios.get(
            `${API_BASE_URL}/BonCommande/clients-with-multiple-orders`,
            {
                headers: {
                    Authorization: `Bearer ${ATUH_TOKEN}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching clients with multiple orders:', error);
        throw error;
    }
};
